import PropTypes from 'prop-types'
import tiendaStyles from '../tiendasoficiales/TiendasOficiales.module.css'

const Banners = ({ bannerPath, nombreTienda }) => {
  return (
    <div className={tiendaStyles.bannerContainer}>
      <img className={tiendaStyles.bannerImg} src={bannerPath} alt="banner" />
      {nombreTienda && (
        <div className={tiendaStyles.bannerOverlay}>
          <span className={tiendaStyles.bannerNombre}>{nombreTienda}</span>
        </div>
      )}
    </div>
  )
}

Banners.propTypes = {
  bannerPath: PropTypes.string.isRequired,
  nombreTienda: PropTypes.string
}

export default Banners
